module.exports = __webpack_public_path__ + "img/psychology.d8383bd4.png";